import { css } from '@emotion/react';
import { theme } from '../../theme/theme';
import type { CodeBlockTone } from './CodeBlock';

export const codeBlockStyle = (tone: CodeBlockTone) => css`
  margin: 0;
  padding: ${theme.space.md}px;
  border: 1px solid ${tone === 'danger' ? `${theme.color.danger}4D` : theme.color.border};
  border-radius: ${theme.radius.md}px;
  background: ${tone === 'danger' ? theme.color.surface : theme.color.bg};
  color: ${tone === 'danger' ? theme.color.danger : theme.color.text};
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: ${theme.fontSize.sm}px;
  overflow-x: auto;
  white-space: ${tone === 'danger' ? 'pre-wrap' : 'pre'};
`;
